import React from 'react';
const facts = [{
  value: '57',
  label: 'Run Sheets, one per session'
}, {
  value: '6',
  label: 'Volumes, one per stage of a table'
}, {
  value: '20 min',
  label: 'One read before you run it'
}, {
  value: '25',
  label: 'Worksheets to plan, track and debrief'
}];
export function SocialProofBar() {
  return <section className="w-full bg-plum-deep" data-id="element-258" data-mp="25tvl7k1ock36">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-259" data-mp="25r0zzqau6v8p">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-plum-line bg-plum-line sm:grid-cols-4" data-id="element-260" data-mp="32htjkxwzb5f8">
          {facts.map(fact => <div key={fact.label} className="bg-plum px-4 py-5 text-center" data-id="element-261" data-mp="2thwzl9ljauqi">
              <div className="font-display font-semibold text-3xl sm:text-4xl leading-none text-gold" data-id="element-262" data-mp="2ojbyl7ygk710">
                {fact.value}
              </div>
              <div className="mt-2 text-[10px] font-semibold uppercase tracking-widest text-white/60" data-id="element-263" data-mp="1i419x6x073l1">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}